import React, { ChangeEvent, FormEvent, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CallIcon from '@material-ui/icons/Call';
import { useAppState } from '../../state';
import { MouseEvent } from 'react';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: 'auto',
  },
  media: {
    height: 140,
  },
  button: {
    width: '100%',
  },
});

export default function ActionCard() {
  const classes = useStyles();
  const { URLRoomName } = useParams();
  const { user, getToken, sendSMS, isFetching } = useAppState();
  const [roomName, setRoomName] = useState<string>('');
  const [name, setName] = useState<string>(user?.displayName || '');
  const { isConnecting, connect } = useVideoContext();
  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
    }
  }, [URLRoomName]);
  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handlePhoneChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomName(event.target.value);
  };

  const handleCallSMS = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    getToken(name, roomName).then(token => connect(token));
  };

  return (
    <Card className={classes.root} elevation={3}>
      <CardActionArea>
        <CardMedia className={classes.media} image="/ContactTracer.png" title="Contact" />
        <CardContent>
          <Typography variant="subtitle1">
            Please provide your name to begin a Right To Work check via video call with an NHSP representative. Please
            click “Allow” when prompted for access to your camera and microphone.
          </Typography>
          <form className={classes.root} noValidate autoComplete="off">
            <div>
              <TextField id="standard-name" label="Name" onChange={handleNameChange} />
            </div>
          </form>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<CallIcon />}
          onClick={handleCallSMS}
        >
          join the call
        </Button>
      </CardActions>
    </Card>
  );
}
